/** True for any value a user would read as "the field has something in it". */
export const isFilledValue = (value: unknown): boolean => {
  if (typeof value === 'string') return value.trim().length > 0
  if (typeof value === 'number') return true
  if (typeof value === 'boolean') return value
  if (Array.isArray(value)) return value.length > 0
  return false
}
